<template>
    <div class="region-list">
        <div class="region-list__title">Выберите регион</div>
        <div class="region-list__close" v-close-popup>
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.04327 1.28601L20.4712 20.714" stroke="black" stroke-width="1.5"/>
                <path d="M20.4713 1.28601L1.0433 20.714" stroke="black" stroke-width="1.5"/>
            </svg>
        </div>
        <ul class="list region-list__list">
            <li v-for="item in regions" :key="item.id" :class="{_selected: item.selected}">
                <a :href="item.url">
                    <span>{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "RegionList",
    props: {
        regions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss">
@import "../../scss/base/include";

.region-list {
    position: relative;
    z-index: 1;
    width: 700px;
    background-color: $white-true;
    padding: 40px 60px;

    @include mobile {
        width: 100%;
        padding: 20px 30px;
    }

    &__close {
        position: absolute;
        z-index: 1;
        top: 52px;
        right: 57px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        @include size(22px);

        @include mobile {
            top: 5px;
            right: 5px;
        }

        svg {
            @include size(100%);
        }
    }

    &__title {
        font-style: normal;
        font-weight: 500;
        font-size: 38px;
        line-height: 48px;
        color: $text-color2;
        margin-bottom: 20px;
        @include mobile {
            font-size: 26px;
        }
    }

    &__list {
        max-width: 490px;
        margin-bottom: 0;
        column-count: 2;
        @include mobile {
            column-count: 1;
        }

        li {
            display: inline-block;
            vertical-align: top;
            width: 100%;
            break-inside: avoid;
            font-size: 20px;
            line-height: 42px;
            padding-left: 35px;
            margin-bottom: 12px;

            @include mobile {
                font-size: 16px;
                margin-bottom: 5px;
                &:not(:last-child) {
                    margin-bottom: 5px;
                }
            }

            &::before {
                left: 15px;
                top: 18px;
            }

            &._selected {
                background-color: $accent;
                color: $white-true;
                border-radius: 5px;
                pointer-events: none;

                &::before {
                    background-color: $white-true;
                }

                a > span::before {
                    display: none !important;
                }
            }
        }

        a {
            position: relative;
            display: inline-block;
            vertical-align: top;

            &:hover > span {
                &::before {
                    width: 100%;
                }
            }

            > span {
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    top: calc(100% + 3px);
                    width: 0;
                    height: 2px;
                    background-color: #ffda00;
                    transition: width .2s linear;
                }
            }
        }
    }
}
</style>
